// @ts-ignore
const translations = {
  // General
  setting: 'Settings',
  welcomeMessage: 'Welcome to GENIO',
}

export default translations
